module.exports = __webpack_public_path__ + "static/media/81zkybKpLBL._AC_SL1500_.f463d2d1.jpg";